module.exports = {"custName":"公司名称","address":"客户地址","industry":"客户行业","size":"客户规模","regMoney":"注册资本","notes":"经营范围","dataSource":"数据来源"}


//////////////////
// WEBPACK FOOTER
// ./src/dict.json
// module id = +9id
// module chunks = 111